// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ou-0";
export var animationContainer = "_ou-1";
export var itemPrice = "_ou-a";
export var itemizedContent = "_ou-9";
export var itemizedHeader = "_ou-7";
export var itemizedRow = "_ou-8";
export var itemizedSection = "_ou-6";
export var modalContent = "_ou-2";
export var orderName = "_ou-3";
export var refundOption = "_ou-4";
export var refundOptionsContainer = "_ou-5";
export var shippingLabel = "_ou-b";
export var totalRow = "_ou-c";